/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Int64OptionDTO,
  Int64OptionDTOQueryResultDTO,
  OrganizationSemesterDropdownGetManyParams
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const organizationSemesterDropdownGetMany = (
    organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Int64OptionDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/OrganizationSemesterDropdown/options`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationSemesterDropdownGetManyQueryKey = (organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams,) => {
    return [`/api/organizations/${organizationId}/OrganizationSemesterDropdown/options`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationSemesterDropdownGetManyQueryOptions = <TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationSemesterDropdownGetManyQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>> = ({ signal }) => organizationSemesterDropdownGetMany(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationSemesterDropdownGetManyQueryResult = NonNullable<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>>
export type OrganizationSemesterDropdownGetManyQueryError = ErrorType<unknown>


export function useOrganizationSemesterDropdownGetMany<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  OrganizationSemesterDropdownGetManyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>,
          TError,
          Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationSemesterDropdownGetMany<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>,
          TError,
          Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationSemesterDropdownGetMany<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationSemesterDropdownGetMany<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationSemesterDropdownGetManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetMany>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationSemesterDropdownGetManyQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationSemesterDropdownGetOne = (
    organizationId: number,
    semesterId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Int64OptionDTO>(
      {url: `/api/organizations/${organizationId}/OrganizationSemesterDropdown/${semesterId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationSemesterDropdownGetOneQueryKey = (organizationId: number,
    semesterId: number,) => {
    return [`/api/organizations/${organizationId}/OrganizationSemesterDropdown/${semesterId}`] as const;
    }

    
export const getOrganizationSemesterDropdownGetOneQueryOptions = <TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError = ErrorType<unknown>>(organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationSemesterDropdownGetOneQueryKey(organizationId,semesterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>> = ({ signal }) => organizationSemesterDropdownGetOne(organizationId,semesterId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && semesterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationSemesterDropdownGetOneQueryResult = NonNullable<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>>
export type OrganizationSemesterDropdownGetOneQueryError = ErrorType<unknown>


export function useOrganizationSemesterDropdownGetOne<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>,
          TError,
          Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationSemesterDropdownGetOne<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>,
          TError,
          Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationSemesterDropdownGetOne<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationSemesterDropdownGetOne<TData = Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationSemesterDropdownGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationSemesterDropdownGetOneQueryOptions(organizationId,semesterId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



